import { EditorView } from 'prosemirror-view';
import type { TPositionItems } from '../../lib/PositionableTextDocument';
import { getMeasurements } from '@src/utils/wysiwyg_editor/proseMeasurements';

function convertPositionItemsToPercentages(
  viewDomNode: HTMLElement,
  positionItems: TPositionItems
) {
  const viewDomNodeOffsetGrandParent = viewDomNode.offsetParent.offsetParent;
  const offsetParentStyles = getComputedStyle(viewDomNodeOffsetGrandParent);
  const offsetParentHeight = parseInt(offsetParentStyles.height, 10);
  const offsetParentWidth = parseInt(offsetParentStyles.width, 10);

  return positionItems.map((item) => {
    const newItem = { ...item };

    newItem.x = parseFloat((newItem.x / offsetParentWidth).toFixed(5));
    newItem.y = parseFloat((newItem.y / offsetParentHeight).toFixed(5));
    newItem.h = parseFloat((newItem.h / offsetParentHeight).toFixed(5));
    newItem.w = parseFloat((newItem.w / offsetParentWidth).toFixed(5));
    newItem.a = parseFloat((newItem.a / offsetParentHeight).toFixed(5));
    newItem.d = parseFloat((newItem.d / offsetParentHeight).toFixed(5));

    return newItem;
  });
}

function valueWithPxUnlessZero(value) {
  return value.toString === '0' ? value : value + 'px';
}

export function viewToPositionItems(view: EditorView) {
  const clonedNode = view.dom.cloneNode(true);
  const clientRect = view.dom.getBoundingClientRect();

  const offsetTop = view.dom.offsetTop;
  const offsetLeft = view.dom.offsetLeft;
  const height = clientRect.height;
  const width = clientRect.width;

  clonedNode.style.opacity = 0;
  clonedNode.style.position = 'absolute';
  clonedNode.style.top = valueWithPxUnlessZero(offsetTop);
  clonedNode.style.left = valueWithPxUnlessZero(offsetLeft);
  clonedNode.style.width = valueWithPxUnlessZero(width);
  clonedNode.style.height = valueWithPxUnlessZero(height);

  view.dom.parentElement.appendChild(clonedNode);

  const position = convertPositionItemsToPercentages(
    clonedNode,
    getMeasurements(clonedNode)
  );

  clonedNode.remove();

  return position;
}
